import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";
import bg1 from "../../assets/images/bg/galleryVideo.jpg";
import bg from "../../assets/images/bg/galleryVideo-m.jpg";

export default function GalleryVideo() {
  const navigate = useNavigate();
  const [blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [noData, setNoData] = useState(false); // No data available state
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // Number of items per page

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchBlogData = async () => {
      setLoading(true); // Set loading to true when fetching starts
      try {
        const docRef = doc(firestore, "Other", "OtherGalleryVideo");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = Object.entries(docSnap.data()).map(([key, value]) => ({
            Id: key,
            ...value,
          }));
          const sortedData = data.sort((a, b) => a.Priority - b.Priority);
          setBlog(sortedData);
          setNoData(sortedData.length === 0); // Set noData based on the length of data
        } else {
          setBlog([]);
          setNoData(true); // Set noData to true if no data exists
        }
      } catch (error) {
        console.error("Error fetching videos: ", error);
        setNoData(true); // Set noData to true in case of an error
      } finally {
        setLoading(false); // Set loading to false once fetching is complete
      }
    };
    fetchBlogData();
  }, []);

  const groupedByCategory = blog.reduce((acc, item) => {
    if (!acc[item.Categories]) {
      acc[item.Categories] = [];
    }
    acc[item.Categories].push(item);
    return acc;
  }, {});

  const handleCategoryClick = (category) => {
    navigate(`/videos-list/${category}`, {
      state: { category, items: groupedByCategory[category] },
    });
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = Object.entries(groupedByCategory).slice(
    startIndex,
    endIndex
  );
  const totalPages = Math.ceil(
    Object.keys(groupedByCategory).length / itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-light nav-left"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          marginTop: isMobile ? "2rem" : "",
        }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title text-white title-dark">
                  Gallery Videos
                </h3>
                <p className="para-desc mx-auto text-white-50">
                  A play is not just words on a page; it's life unfolding in
                  real time, a shared breath between performer and audience.
                </p>
                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li style={{color:"#B9B569"}} className="breadcrumb-item active" aria-current="page">
                      Gallery Videos
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ marginBottom: "1.5rem" }}>
        <div className="container">
          {loading ? (
            <div className="text-center">
              <h5>Loading...</h5>
            </div>
          ) : noData ? (
            <div className="text-center">
              <h5>No Videos Available</h5>
            </div>
          ) : (
            <div className="row">
              {paginatedItems?.map(([category, items]) => {
                const embedUrl =
                  "https://www.youtube.com/embed/" +
                  items[0].Link.split("=")[1];
                return (
                  <div
                    className="col-lg-4 col-md-6 col-12 mb-4 pb-2"
                    key={category}
                    onClick={() => handleCategoryClick(category)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                      <iframe
                        width="100%"
                        height="220"
                        src={embedUrl}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={category}
                      ></iframe>
                    </div>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "1rem",
                        textTransform: "capitalize",
                        fontSize: "18px",
                        fontWeight: 500,
                      }}
                      className="justify six-line-truncate"
                    >
                      {category}
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <button
                        style={{
                          backgroundColor: "#B9B568",
                          border: "#B9B568",
                        }}
                        onClick={() => handleCategoryClick(category)}
                        className="btn btn-primary btn-sm" // Added btn-sm for small size
                      >
                        Click For More
                      </button>
                    </div>
                  </div>
                );
              })}
              <div className="d-flex justify-content-center mt-4">
                <nav>
                  <ul className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          style={{ backgroundColor: "#B9B568" }}
                          className="page-link"
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
      <ScrollTop />
    </>
  );
}
